<template>
  <main-container v-if="isBasicRoute">
    <a-card>
      <div class="new_btn_box">
        <a-button
          type="item"
          class="new_btn"
          :class="choose == 0 ? 'choose_btn' : ''"
          @click="loadUserList"
          style="margin-right: 30px"
        >
          <span>全部用户</span>
        </a-button>
        <a-button
          type="item"
          class="new_btn"
          :class="choose == 1 ? 'choose_btn' : ''"
          @click="getNewUserList"
          style="margin-right: 30px"
        >
          <span style="margin-right: 5px">新用户</span>({{ NewUserListLenth }})
        </a-button>
        <a-button
          type="item"
          class="new_btn"
          :class="choose == 2 ? 'choose_btn' : ''"
          @click="getOwingUserList"
          style="margin-right: 30px"
        >
          <span style="margin-right: 5px">欠款用户</span>({{ OwingUseListLength }})
        </a-button>
      </div>

      <div class="table-query">
        <a-form-model ref="queryFormRef" :model="queryForm" :rules="queryFormRules">
          <a-row :gutter="24">
            <a-col :md="8">
              <a-form-model-item>
                <a-input placeholder="请输入手机号、名称、城市" v-model="queryForm.con"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col class="table-query-action" :md="8">
              <a-form-model-item>
                <a-button type="primary" @click="handleQueryClick">
                  <a-icon type="search"></a-icon>
                  查询
                </a-button>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>

      <a-table
        row-key="user_id"
        :loading="loading"
        :columns="columns"
        :data-source="dataSource"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <template slot="validOrder" slot-scope="record">
          <router-link :to="{ name: $routeName.memberOrderList, query: { user_id: record.user_id, range: 'valid' } }">
            {{ record.valid_order_num }}
          </router-link>
        </template>
        <template slot="order" slot-scope="record">
          <router-link :to="{ name: $routeName.memberOrderList, query: { user_id: record.user_id, range: 'wu' } }">
            {{ record.order_num }}
          </router-link>
        </template>
        <template slot="owing" slot-scope="record">
          <span v-if="record.amount_owed != '0.00'" style="color: red;">{{ record.amount_owed }}</span>
        </template>
        <template slot="action" slot-scope="record">
          <router-link :to="{ name: $routeName.memberDetail, query: { id: record.user_id } }">查看</router-link>
        </template>
      </a-table>
    </a-card>
  </main-container>
  <router-view v-else></router-view>
</template>

<script>
import Member from '@/api/member';
const columns = [
  {
    title: '序号',
    dataIndex: 'num',
    width: 10,
  },
  {
    title: '用户ID',
    dataIndex: 'user_id',
    width: 20,
  },
  {
    title: '会员等级',
    dataIndex: 'user_level',
    width: 30,
  },
  {
    title: '用户昵称',
    dataIndex: 'name',
    width: 60,
  },
  {
    title: '注册账号',
    dataIndex: 'register_account',
    width: 80,
  },
  {
    title: '注册时间',
    dataIndex: 'create_time',
    width: 80,
  },
  {
    title: '手机号',
    dataIndex: 'phone',
    width: 60,
  },
  {
    title: '邮箱号',
    dataIndex: 'email',
    width: 60,
  },
  {
    title: '用户所在国家',
    dataIndex: 'country',
    width: 60,
  },
  {
    key: 'validOrder',
    title: '有效次数',
    width: 30,
    scopedSlots: { customRender: 'validOrder' },
  },
  {
    key: 'order',
    title: '下单次数',
    width: 30,
    scopedSlots: { customRender: 'order' },
  },
  {
    title: '余额',
    width: 30,
    dataIndex: 'balance',
  },
  {
    key: 'owing',
    title: '欠款',
    width: 30,
    scopedSlots: { customRender: 'owing' },
  },
  {
    key: 'action',
    title: '操作',
    width: 30,
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  name: 'MemberList',

  data() {
    return {
      columns,
      loading: false,
      dataSource: [],
      queryForm: {
        con: undefined,
      },
      pagination: {
        current: 1,
        pageSize: 10,
        'show-size-changer': true,
        'show-total': total => `共 ${total} 条`,
      },
      queryFormRules: {},
      NewUserListLenth: 0,
      OwingUseListLength: 0,
      choose: 0,
    };
  },

  computed: {
    isBasicRoute() {
      return this.$route.name === this.$routeName.memberList;
    },
  },

  created() {
    this.loadUserList();
    this.getNewUserListLenth();
    this.getOwingUserListLenth();
  },

  methods: {
    handleQueryClick() {
      this.pagination.current = 1;
      this.loadUserList();
    },
    //全部用户
    loadUserList() {
      this.choose = 0;
      this.loading = true;
      Member.userList({
        ...this.queryForm,
        page: this.pagination.current,
        page_limit: this.pagination.pageSize,
      })
        .then(({ data }) => {
          this.pagination = {
            total: data.total_items,
            current: data.page,
            pageSize: data.page_limit,
          };
          this.dataSource = data.list;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //新用户
    getNewUserList() {
      this.choose = 1;
      this.loading = true;
      Member.newUserList({
        ...this.queryForm,
        page: this.pagination.current,
        page_limit: this.pagination.pageSize,
      })
        .then(({ data }) => {
          this.pagination = {
            total: data.total_items,
            current: data.page,
            pageSize: data.page_limit,
          };
          this.dataSource = data.list;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getNewUserListLenth() {
      Member.newUserList({
        ...this.queryForm,
        page: this.pagination.current,
        page_limit: this.pagination.pageSize,
      }).then(({ data }) => {
          this.NewUserListLenth = data.total_items;
        }).finally(() => {});
    },
    //欠款用户
    getOwingUserList() {
      this.choose = 2;
      this.loading = true;
      Member.owingUserList({
        ...this.queryForm,
        page: this.pagination.current,
        page_limit: this.pagination.pageSize,
      })
        .then(({ data }) => {
          this.pagination = {
            total: data.total_items,
            current: data.page,
            pageSize: data.page_limit,
          };
          this.dataSource = data.list;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getOwingUserListLenth() {
      Member.owingUserList({
        ...this.queryForm,
        page: this.pagination.current,
        page_limit: this.pagination.pageSize,
      })
        .then(({ data }) => {
          this.OwingUseListLength = data.total_items;
        })
        .finally(() => {});
    },
    handleTableChange(pagination) {
      this.pagination = pagination;
      if (this.choose == 1) {
        this.getNewUserList();
      } else if (this.choose == 2) {
        this.getOwingUserList();
      } else {
        this.loadUserList();
      }
    },
  },
};
</script>

<style scoped>
.new_btn {
  /*float: left;*/
  margin-top: 4px;
}
.choose_btn {
  color: #1890ff;
  border: 1px solid #1890ff;
}
</style>